import api from "../../utils/API";

const getAllDirectionForSelect = () => {
    return api.get(`/AllDirection/list`);
};

export {getAllDirectionForSelect};